import React from 'react'
import InventoryView from './InventoryView'
import { usePickupContext } from '../../context/PickupContext'
import { PowerBankCityProvider } from 'Components/PowerBanks/PowerBankCityContext'

export const PickupAll = ({
  givenOutCodes,
  availableCodes,
  missions,
  updateLocalInventoryState,
  isFetching,
  ...otherProps
}) => {
  const { pickupContextState } = usePickupContext()

  const {
    selectedBrandAmbassadors,
    selectedCampaigns,
    selectedClients,
    selectedMerchTypes,
    brandAmbassadors,
    clients,
    campaigns,
    showOnlyBooked,
    cityId,
  } = pickupContextState

  return (
    <PowerBankCityProvider cityId={cityId}>
      <InventoryView
        updateLocalInventoryState={updateLocalInventoryState}
        brandAmbassadors={
          selectedBrandAmbassadors ? selectedBrandAmbassadors : brandAmbassadors
        }
        clients={(() => {
          var theClients = selectedClients ? selectedClients : clients
          if (selectedCampaigns) {
            return theClients.filter(client =>
              selectedCampaigns.find(cam => cam.client.id == client.id),
            )
          } else {
            return theClients
          }
        })()}
        campaigns={selectedCampaigns ? selectedCampaigns : campaigns}
        selectedMerch={selectedMerchTypes}
        givenOutCodes={givenOutCodes}
        availableCodes={availableCodes}
        missions={showOnlyBooked ? missions.filter(m => m.isBooked) : missions}
        isFetching={isFetching}
        {...otherProps}
      />
    </PowerBankCityProvider>
  )
}
